import React, { useState, useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import Image from "components/Elements/Image/Image.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useModal } from "contexts/modalContext/modalContext.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useUser } from "contexts/userContext/userContext.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import SetFooterLinksModal from "../Modals/SetFooterLinksModal.js";

const FooterPersonalPage = ({
  pageMode,
  FullDetailsEmbedPage,
  linkFooters,
  setLinkFooters,
  isOpen,
}) => {
  const { setModal } = useModal();
  const { isSubscribed } = useUser();
  const [editCustomFooterLinks, setEditCustomFooterLinks] = useState(false);

  const { getTextByKey } = useContent();
  useEffect(() => {
    if (editCustomFooterLinks && linkFooters) {
      updateFooter();
    }
  }, [editCustomFooterLinks, linkFooters]);

  //update embed page footer //        public List<JMFooterLinkListBase> FooterLinks { get; set; }

  const updateFooter = async () => {
    const body = {
      FooterLinks: linkFooters,
      EmbedDynamicPageId: FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageId,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "UpdateEmbedPageFooter",
      body,
      "POST"
    );
    if (response.status === "success") {
    }
  };

  const handleClickEditButton = () => {
    if (!isSubscribed()) {
      setModal(() => <EmbedLimitOptionsModal />);
    } else {
      setModal(() => (
        <SetFooterLinksModal
          hideDisplayToggle={true}
          linkFooters={linkFooters}
          setLinkFooters={setLinkFooters}
          editCustomFooterLinks={editCustomFooterLinks}
          setEditCustomFooterLinks={setEditCustomFooterLinks}
        />
      ));
    }
  };

  return (
    <div className={`footer-page`}>
      {pageMode === "edit" && !isOpen && (
        <div className="edit-footer">
          <div className="edit-button" onClick={() => handleClickEditButton()}>
            <Icon name="pencil-alt-solid" />
            <span> {getTextByKey("edit-button-personal-page")}</span>
          </div>
        </div>
      )}
      <div className="footer-links">
        {linkFooters.map((item, i) => (
          <div key={i} className="footer-item">
            <LinkToNewTab fullUrl={true} isNewTab page={item.FooterLinkUrl}>
              {item.FooterLinkTitle}
            </LinkToNewTab>
          </div>
        ))}
      </div>
      <div className="powered-side">
        <LinkToNewTab isNewTab page={"home"} ariaLabel="home-page">
          <Image name={`jumbomail-logo-black`} ext="svg" />
        </LinkToNewTab>
      </div>
    </div>
  );
};

export default FooterPersonalPage;
